<div class="clug-form-modal" [formGroup]="clientForm">
  <div class="clug-form-modal-loader" *ngIf="loading">
    <div class="auth-spinner" aria-label="Loading"></div>
  </div>

  <div class="modal-head">
    <div class="title-block">
      <h2>Add Client</h2>
      <span class="sub">Create a new client and add the people who'll approve their timesheets.</span>
    </div>
    <button type="button" class="close-btn" title="Close" (click)="onClose()">
      <i class="bi bi-x-lg"></i>
    </button>
  </div>

  <div class="modal-subtabs">
    <button type="button" class="modal-subtab" [class.active]="activeSubpanel === 'details'"
      (click)="setSubpanel('details')">
      Details
    </button>
    <button type="button" class="modal-subtab" [class.active]="activeSubpanel === 'contacts'"
      (click)="setSubpanel('contacts')">
      Contacts
      <span class="count">{{ client_contacts.length }}</span>
    </button>
  </div>

  <div class="modal-body tight">

    <!-- Details subpanel -->
    <div *ngIf="activeSubpanel === 'details'">
      <div class="form-section">
        <div class="form-section-head">
          <span class="title">
            <span class="ico"><i class="bi bi-building"></i></span>
            Client details
          </span>
          <span class="req-pill">Required</span>
        </div>
        <div class="grid-2">
          <div class="field tight full">
            <label>Client name <span class="req">*</span></label>
            <input type="text" class="input-form" id="clientName" formControlName="name"
              placeholder="e.g. Acme Industries" (blur)="clientValidation($event)" />
          </div>
          <div class="field tight">
            <label>Identifier <span class="hint">(optional)</span></label>
            <input type="text" class="input-form" formControlName="identifier" placeholder="e.g. ACME-001" />
          </div>
          <div class="field tight">
            <label>Currency</label>
            <div class="select-wrap">
              <select class="input-form" formControlName="currency_format">
                <option value="">Select currency</option>
                <option *ngFor="let cf of dataSharedService.currencyFormatList" [value]="cf">{{ cf }}</option>
              </select>
            </div>
          </div>
          <div class="field tight">
            <label>VAT applicable?</label>
            <div class="seg">
              <button type="button" [class.on]="clientForm.value.is_vat_applicable !== 1"
                (click)="setVat(0)">No</button>
              <button type="button" [class.on]="clientForm.value.is_vat_applicable === 1"
                (click)="setVat(1)">Yes</button>
            </div>
          </div>
          <div class="field tight full">
            <label>Billing address</label>
            <textarea class="input-form" rows="2" formControlName="address_1"
              placeholder="Street, city, post code, country"></textarea>
          </div>
        </div>
      </div>
    </div>

    <!-- Contacts subpanel -->
    <div *ngIf="activeSubpanel === 'contacts'">
      <div class="form-section">
        <div class="form-section-head">
          <span class="title">
            <span class="ico"><i class="bi bi-people"></i></span>
            Client contacts
            <span class="hint">people who approve timesheets</span>
          </span>
          <span class="req-pill">At least 1</span>
        </div>

        <div>
          <div class="contact-card" *ngFor="let contact of client_contacts; index as i"
            [class.open]="openContacts.has(i)">
            <div class="contact-head" (click)="toggleContact(i)">
              <div class="lhs">
                <i class="bi bi-chevron-down chev"></i>
                <div class="avatar">{{ getInitials(contact) }}</div>
                <div class="who">
                  <div class="name" *ngIf="contact.first_name || contact.last_name">
                    {{ contact.first_name }} {{ contact.last_name }}
                  </div>
                  <div class="name" *ngIf="!contact.first_name && !contact.last_name">
                    <span class="placeholder">New contact</span>
                  </div>
                  <div class="sub" *ngIf="contact.email">
                    {{ contact.email }} ·
                    {{ contact.timesheet_notification_settings.email_type === 1
                        ? 'Bulk · ' + dayName(contact.timesheet_notification_settings.day) + ' ' + contact.timesheet_notification_settings.time
                        : 'Individual approval' }}
                  </div>
                  <div class="sub" *ngIf="!contact.email">No email yet</div>
                </div>
              </div>
              <div class="rhs">
                <span class="invite-chip" *ngIf="contact.send_invite">
                  <i class="bi bi-envelope-check"></i>Invite
                </span>
                <button type="button" class="icon-btn-sm-ghost" title="Remove contact"
                  *ngIf="client_contacts.length > 1"
                  (click)="removeContact(i, $event)">
                  <i class="bi bi-trash"></i>
                </button>
              </div>
            </div>
            <div class="contact-body">
              <div class="grid-2">
                <div class="field tight">
                  <label>First name <span class="req">*</span></label>
                  <input type="text" class="input-form" [(ngModel)]="contact.first_name"
                    [ngModelOptions]="{standalone: true}" placeholder="e.g. Lara"
                    (input)="ClientContactValidation($event)" />
                </div>
                <div class="field tight">
                  <label>Last name <span class="req">*</span></label>
                  <input type="text" class="input-form" [(ngModel)]="contact.last_name"
                    [ngModelOptions]="{standalone: true}" placeholder="e.g. Chen"
                    (input)="ClientContactValidation($event)" />
                </div>
                <div class="field tight full">
                  <label>Email <span class="req">*</span></label>
                  <input type="email" class="input-form" [(ngModel)]="contact.email"
                    [ngModelOptions]="{standalone: true}" placeholder="name@company.com"
                    (input)="ClientContactValidation($event)" />
                </div>

                <div class="field tight full">
                  <label>Approval email style</label>
                  <div class="seg">
                    <button type="button"
                      [class.on]="contact.timesheet_notification_settings.email_type === 0"
                      (click)="contact.timesheet_notification_settings.email_type = 0">
                      <i class="bi bi-envelope"></i>Individual
                    </button>
                    <button type="button"
                      [class.on]="contact.timesheet_notification_settings.email_type === 1"
                      (click)="contact.timesheet_notification_settings.email_type = 1">
                      <i class="bi bi-collection"></i>Bulk digest
                    </button>
                  </div>
                  <span class="hint">
                    {{ contact.timesheet_notification_settings.email_type === 1
                       ? 'Bulk: one email per cycle covering every contractor.'
                       : 'Individual: one approval email per contractor, sent on submission.' }}
                  </span>
                </div>

                <ng-container *ngIf="contact.timesheet_notification_settings.email_type === 1">
                  <div class="field tight">
                    <label>Frequency</label>
                    <div class="select-wrap">
                      <select class="input-form"
                        [(ngModel)]="contact.timesheet_notification_settings.frequency"
                        [ngModelOptions]="{standalone: true}">
                        <option [ngValue]="1">Weekly</option>
                        <option [ngValue]="2">Monthly</option>
                      </select>
                    </div>
                  </div>
                  <div class="field tight">
                    <label>Day</label>
                    <div class="select-wrap">
                      <select class="input-form"
                        [(ngModel)]="contact.timesheet_notification_settings.day"
                        [ngModelOptions]="{standalone: true}">
                        <option [ngValue]="0">Sunday</option>
                        <option [ngValue]="1">Monday</option>
                        <option [ngValue]="2">Tuesday</option>
                        <option [ngValue]="3">Wednesday</option>
                        <option [ngValue]="4">Thursday</option>
                        <option [ngValue]="5">Friday</option>
                        <option [ngValue]="6">Saturday</option>
                      </select>
                    </div>
                  </div>
                  <div class="field tight">
                    <label>Time</label>
                    <input type="time" class="input-form" min="06:00:00" max="20:00:00"
                      [(ngModel)]="contact.timesheet_notification_settings.time"
                      [ngModelOptions]="{standalone: true}"
                      (change)="ClientContactValidation($event)" />
                  </div>
                </ng-container>

                <div class="field tight full">
                  <div class="toggle-row">
                    <div class="meta">
                      <span class="label">Send invite email</span>
                      <span class="sub">Email this contact a one-click approval link.</span>
                    </div>
                    <button type="button" class="switch" [class.on]="contact.send_invite"
                      (click)="contact.send_invite = !contact.send_invite"
                      [attr.aria-pressed]="contact.send_invite"></button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <button type="button" class="ghost-add-btn" (click)="addContact()">
          <i class="bi bi-plus-lg"></i>Add another contact
        </button>
      </div>
    </div>

    <div class="form-error" *ngIf="error">
      <i class="bi bi-exclamation-triangle-fill"></i>
      <span>{{ error }}</span>
    </div>
  </div>

  <div class="modal-foot">
    <div class="left">
      <i class="bi bi-info-circle"></i>
      <span>Required fields marked <span class="req">*</span>. Save to create the record.</span>
    </div>
    <div class="right">
      <button type="button" class="btn btn-secondary" (click)="onClose()">Cancel</button>
      <button type="submit" class="btn btn-primary" [disabled]="loading || !formValid || !clientformValid"
        (click)="onSubmit()">
        <i class="bi bi-check-lg"></i>Save
      </button>
    </div>
  </div>
</div>
